import {
  blueColorStyle,
  greenColorStyle,
  pinkColorStyle,
  purpleColorStyle,
  redColorStyle,
  yellowColorStyle,
} from './styles';

export const SUGGESTIONS: string[] = [
  'Happy birthday! 🍰',
  'Congrats! 🎉',
  'Best of luck ☘️',
  'Welcome onboard 👨‍💻',
  'Feel better soon ❤️',
  'Thank you 😊',
];

export const COLORS: {
  background: string;
  '&:hover': { background: string };
}[] = [
  purpleColorStyle,
  redColorStyle,
  greenColorStyle,
  yellowColorStyle,
  pinkColorStyle,
  blueColorStyle,
];
